// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

const bridgeGetObject = objectOf({
  id: string,
  external_id: string,
  status: enumOf(1, 2),
  processing: boolean,
  connected_at: anyOf(string, nullOrUndefined),
  disconnected_at: anyOf(string, nullOrUndefined),
  enabled_user_events: anyOf(boolean, nullOrUndefined),
  external_id_type: anyOf(string, nullOrUndefined),
  custom_id_endpoint: anyOf(string, nullOrUndefined),
  enabled_in_browser_messaging: anyOf(boolean, nullOrUndefined),
  enabled_banners: anyOf(boolean, nullOrUndefined),
});

export const isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult = objectOf({
  bridges: arrayOf(bridgeGetObject),
});

export const isDeleteAlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult = objectOf({
  message: string,
});
